module.exports = __webpack_public_path__ + "static/img/Band_nato_black.d00b1c6.jpg";